import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FrameSpecification',
    props: {
        itemSize: null,
        frameSize: null,
        length: null,
        hasMount: { type: Boolean },
        mount: null,
        glazing: null,
        fixings: null,
        unitPrice: null,
        validation: null
    },
    setup(__props) {
        const props = __props;
        const frameDescription = computed(() => props.hasMount
            ? `${props.frameSize.name} to fit ${props.itemSize.name} item`
            : `${props.itemSize.name} (No Mount)`);
        return { __sfc: true, props, frameDescription, computed };
    }
});
